/* Mobellia — search (built by ovanap.dev team).
 * Header search overlay + predictive (as-you-type) product suggestions via the
 * Section Rendering API. Progressive enhancement: with JS off, the header search
 * icon still links to /search and the search page form still works.
 */
(function () {
  var overlay = document.querySelector('[data-search-overlay]');

  function openOverlay() {
    if (!overlay) return;
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    document.documentElement.classList.add('m-search-open');
    var inp = overlay.querySelector('[data-predictive-input]');
    if (inp) setTimeout(function () { inp.focus(); }, 40);
  }
  function closeOverlay() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('m-search-open');
    setTimeout(function () { if (!overlay.classList.contains('is-open')) overlay.hidden = true; }, 340);
  }

  // Open from the header search icon (link to /search) — enhance, keep fallback.
  document.querySelectorAll('[data-search-open], .m-header__icons a[aria-label="Søk"]').forEach(function (t) {
    t.addEventListener('click', function (e) { if (overlay) { e.preventDefault(); openOverlay(); } });
  });
  document.querySelectorAll('[data-search-close]').forEach(function (b) { b.addEventListener('click', closeOverlay); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay && !overlay.hidden) closeOverlay(); });

  // Predictive search for any [data-predictive-input] (overlay + results page).
  function setupPredictive(input) {
    if (!input || input.dataset.psReady) return;
    input.dataset.psReady = '1';
    var scope = input.closest('.m-search__panel, .m-searchpage__head') || document;
    var results = scope.querySelector('[data-predictive-results]');
    var clearBtn = scope.querySelector('[data-search-clear]');
    if (!results) return;
    // Regular search index (reliable) via Section Rendering API.
    var base = results.getAttribute('data-predictive-url') || '/search';
    var timer, lastReq = 0;
    function run() {
      // Front-end normalization only (casing/whitespace). Shopify search is already
      // case-insensitive and matches Norwegian ø/å natively, so we do NOT strip
      // diacritics here (that would turn "hjørnesofa" -> "hjornesofa" and miss hits).
      // Singular/plural + variant matching lives in Search & Discovery synonyms.
      var q = input.value.trim().toLowerCase().replace(/\s+/g, ' ');
      if (q.length < 2) { results.innerHTML = ''; return; }
      var url = base + '?q=' + encodeURIComponent(q) + '&type=product&section_id=predictive-search';
      var req = ++lastReq;
      fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (req !== lastReq) return; // ignore out-of-order responses
        if (!html) { results.innerHTML = ''; return; }
        var node = new DOMParser().parseFromString(html, 'text/html').querySelector('.m-psearch');
        results.innerHTML = node ? node.outerHTML : '';
      }).catch(function () {});
    }
    function toggleClear() { if (clearBtn) clearBtn.hidden = input.value.length === 0; }
    input.addEventListener('input', function () { toggleClear(); clearTimeout(timer); timer = setTimeout(run, 220); });
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = ''; results.innerHTML = ''; toggleClear(); input.focus();
      });
    }
    toggleClear();
  }

  function init(scope) { (scope || document).querySelectorAll('[data-predictive-input]').forEach(setupPredictive); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(); }); } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
